import React from 'react';

import { BodyCopyTypes, MediaDataTypes } from '@src/typescriptGlobals/contentful.types';

import Container from '../Container';
import NextImage from '../NextImage';
import RenderBodyCopy from '../RenderBodyCopy';

import { SubscriptionTablePropTypes } from './SubscriptionTable.types';

const SubscriptionTable: React.FC<SubscriptionTablePropTypes> = ({
  className,
  data,
  headerImgL,
  headerImgR,
}) => {
  return (
    <Container className={`m-[0]! px-[0]! md:pt-[4rem] ${className}`}>
      <div className='mx-auto max-w-[98rem] rounded-4xl border-[0.5rem] border-[#fff] bg-[#f7f7f7]'>
        <div className='rounded-t-4xl bg-linear-to-r from-[#F4F4F4] via-[#EEEEEE] to-[#E6E6E6]'>
          <ul className='grid min-h-[12rem] gap-[2.4rem] p-[2rem_1rem] md:grid-cols-2 md:gap-[1rem] lg:h-[14.1rem] lg:gap-[2.4rem] lg:p-[0rem_1rem]'>
            <li className='grid grid-cols-[auto_1fr] items-center gap-[1.6rem]  md:gap-[2.2rem]'>
              <NextImage
                className={`${headerImgL} self-center`}
                src={data?.[0]?.extraAssetsCollection?.items?.[0]?.logo?.url}
                alt={data?.[0]?.extraAssetsCollection?.items?.[0]?.logo?.description}
                aspectRatio={100}
                width={100}
              />
              <div>
                <span className='text-pretty text-[2rem] font-medium leading-[2.2rem] lg:text-[2.3rem]'>
                  {data?.[0]?.extraAssetsCollection?.items?.[0]?.title}
                </span>
                <RenderBodyCopy
                  className='mt-[0.8rem] [&>p]:leading-[1.8rem] lg:[&>p]:text-[1.9rem] lg:[&>p]:leading-[2.2rem]'
                  bodyCopy={data?.[0]?.extraAssetsCollection?.items?.[0]?.bodyCopy?.json?.content}
                />
              </div>
            </li>

            <li className='grid grid-cols-[1fr_auto] items-center gap-[1.6rem] md:grid-cols-[auto_1fr] md:gap-[2.2rem]'>
              <NextImage
                className={`${headerImgR} order-1 self-center md:order-0`}
                src={data?.[0]?.extraAssetsCollection?.items?.[1]?.logo?.url}
                alt={data?.[0]?.extraAssetsCollection?.items?.[1]?.logo?.description}
                aspectRatio={100}
                width={100}
              />

              <div>
                <span className='block text-pretty text-right text-[2rem] font-medium leading-[2.2rem] md:text-left lg:text-[2.3rem]'>
                  {data?.[0]?.extraAssetsCollection?.items?.[1]?.title}
                </span>
                <RenderBodyCopy
                  className='mt-[1rem] text-right md:text-left [&>p]:leading-[1.8rem] lg:[&>p]:text-[1.9rem] lg:[&>p]:leading-[2.2rem]'
                  bodyCopy={data?.[0]?.extraAssetsCollection?.items?.[1]?.bodyCopy?.json?.content}
                />
              </div>
            </li>
          </ul>
        </div>
        <div>
          <ul className='grid p-[3rem] md:grid-cols-2'>
            {data?.[0]?.extraAssetsCollection?.items
              ?.filter(
                (item: {
                  __typename: string;
                  logo: MediaDataTypes;
                  title: string;
                  bodyCopy: BodyCopyTypes;
                }) => item?.__typename === 'Card'
              )
              ?.map(
                (item: {
                  mediaPrimary: MediaDataTypes;
                  logo: MediaDataTypes;
                  title: string;
                  bodyCopy: BodyCopyTypes;
                }) => {
                  return (
                    <>
                      <li className='flex-r flex items-center py-[1rem]'>
                        <NextImage
                          className='max-w-3xs flex-[0_0_4rem] [&>img]:h-[4rem]! [&>img]:w-[4rem]!'
                          src={item?.mediaPrimary?.url}
                          alt={item?.logo?.description}
                          aspectRatio={100}
                          width={100}
                        />
                        <div>
                          <RenderBodyCopy
                            className='pl-[2rem] [&>p]:leading-[2rem] lg:[&>p]:text-[1.9rem]'
                            bodyCopy={item?.bodyCopy?.json?.content}
                          />
                        </div>
                      </li>
                    </>
                  );
                }
              )}
          </ul>
        </div>
      </div>
    </Container>
  );
};

export default SubscriptionTable;
